






import { Component, Vue, Prop } from 'vue-property-decorator';
import DirectoryTable from './DirectoryTable.vue';
import { Directory } from '@/@types/LibraryComponent';

@Component({
  components: {
    DirectoryTable,
  },
})
export default class Directories extends Vue {
  @Prop({ required: true, default: '' })
  private readMeData!: string;
  private isListView: boolean = true;
  private directories: Array<Directory> = [
    {
      name: 'public',
      path: '/folder1',
    },
    {
      name: 'src',
      path: '/folder2',
    },
    {
      name: '.gitignore',
      path: 'txt',
    },
    {
      name: 'README.md',
      path: 'txt',
    },
    {
      name: 'package-lock.json',
      path: 'txt',
    },
    {
      name: 'package.json',
      path: 'txt',
    },
    {
      name: 'tsconfig.json',
      path: 'txt',
    },
    {
      name: 'tslint.json',
      path: 'txt',
    },
    {
      name: 'vue.config.js',
      path: 'txt',
    },
    {
      name: 'yarn.lock',
      path: 'txt',
    },
  ];
}
